import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
import { getOrgSettingsDetails } from "../../connections/getOrgSettingsDetails";
import { deleteOrgSettings } from "../../connections/deleteOrgSettings";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";
// import { Table } from "antd";

const ShowOrgSettings = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const { data: orgSettingsDetailsData, isLoading } = useQuery({
    queryKey: ["getOrgSettingsDetails", id],
    queryFn: () => getOrgSettingsDetails(user?.token, id),
    enabled: !!id,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const handleDeleteData = async (e) => {
    e.preventDefault();
    try {
      const data = await deleteOrgSettings(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Organization Settings Deleted Successfully");
        navigate("/admin/organization_settings");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="origination--list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Organization Settings Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Organization Settings Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate(
                                    "/admin/update-organization_settings",
                                    {
                                      state: orgSettingsDetailsData,
                                    },
                                  );
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(orgSettingsDetailsData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Organization:</span>{" "}
                                  <span className="text">
                                    <Link
                                      to={"/admin/organization"}
                                      style={{ textDecoration: "underline" }}
                                    >
                                      {orgSettingsDetailsData?.organization
                                        ?.name || "NA"}
                                    </Link>
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Page Type:</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.page_type || "NA"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Is Active:</span>{" "}
                                  <span className="text">
                                    <span
                                      className={
                                        orgSettingsDetailsData?.is_active
                                          ? "custom-badge status-green"
                                          : "custom-badge status-pink"
                                      }
                                    >
                                      {" "}
                                      {orgSettingsDetailsData?.is_active
                                        ? "True"
                                        : "False"}
                                    </span>
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Header Height:</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.header_height ||
                                      "NA"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Footer Height:</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.footer_height ||
                                      "NA"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Review Duration</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.review_duration ||
                                      "NA"}
                                  </span>
                                </li>
                                {orgSettingsDetailsData?.page_type ===
                                  "prescription" && (
                                  <li className="pb-1">
                                    <span className="title">
                                      Investigations on Prescription:
                                    </span>{" "}
                                    <span className="text">
                                      <span
                                        className={
                                          orgSettingsDetailsData?.print_investigations_on_prescription
                                            ? "custom-badge status-green"
                                            : "custom-badge status-pink"
                                        }
                                      >
                                        {orgSettingsDetailsData?.print_investigations_on_prescription
                                          ? "True"
                                          : "False"}
                                      </span>
                                    </span>
                                  </li>
                                )}
                                {orgSettingsDetailsData?.page_type ===
                                  "prescription" && (
                                  <li className="pb-1">
                                    <span className="title">
                                      Salts on Prescription:
                                    </span>{" "}
                                    <span className="text">
                                      <span
                                        className={
                                          orgSettingsDetailsData?.print_salts_on_prescription
                                            ? "custom-badge status-green"
                                            : "custom-badge status-pink"
                                        }
                                      >
                                        {orgSettingsDetailsData?.print_salts_on_prescription
                                          ? "True"
                                          : "False"}
                                      </span>
                                    </span>
                                  </li>
                                )}
                                {orgSettingsDetailsData?.page_type ===
                                  "prescription" && (
                                  <li className="pb-1">
                                    <span className="title">
                                      Allow past time slot:
                                    </span>{" "}
                                    <span className="text">
                                      <span
                                        className={
                                          orgSettingsDetailsData?.allow_past_slots
                                            ? "custom-badge status-green"
                                            : "custom-badge status-pink"
                                        }
                                      >
                                        {orgSettingsDetailsData?.allow_past_slots
                                          ? "True"
                                          : "False"}
                                      </span>
                                    </span>
                                  </li>
                                )}
                                <li className="pb-1">
                                  <span className="title">Created At:</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.created_at
                                      ? formatDateTime(
                                          orgSettingsDetailsData?.created_at,
                                        )
                                      : "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>{" "}
                                  <span className="text">
                                    {orgSettingsDetailsData?.updated_at
                                      ? formatDateTime(
                                          orgSettingsDetailsData?.updated_at,
                                        )
                                      : "Empty"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteData}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default ShowOrgSettings;
